import { AnyAction, Dispatch, Middleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import { APP_ENV } from 'src/global/config/common.config';

import { analyticsApi } from '../services/analytics.service';
import { memberApi } from '../services/member.service';
import { networkApi } from '../services/network.service';
import { otcApi } from '../services/otc.service';
import { priceApi } from '../services/price.service';
import { projectDashboardApi } from '../services/project-dashboard.service';
import { projectApi } from '../services/project.service';
import { roleApi } from '../services/role.service';
import { uploadApi } from '../services/upload.service';
import { voteApi } from '../services/vote.service';

const middleware: Middleware[] = [
  projectApi.middleware,
  uploadApi.middleware,
  roleApi.middleware,
  voteApi.middleware,
  otcApi.middleware,
  networkApi.middleware,
  analyticsApi.middleware,
  projectDashboardApi.middleware,
  priceApi.middleware,
  memberApi.middleware,
];

if (APP_ENV === 'development') {
  middleware.push(
    createLogger({
      duration: true,
      timestamp: false,
      collapsed: true,
      colors: {
        title: () => '#139BFE',
        prevState: () => '#1C5FAF',
        action: () => '#149945',
        nextState: () => '#A47104',
        error: () => '#ff0005',
      },
      predicate: () => typeof window !== 'undefined',
    }) as Middleware<Record<string, never>, any, Dispatch<AnyAction>>, // Update the type of the middleware function
  );
}

export { middleware };
